require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-thinklaundry-branding.json") })
        }
      }, "path---projects-thinklaundry-branding");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-thinklaundry-branding!./.cache/json/projects-thinklaundry-branding.json
// module id = 368
// module chunks = 231608221292675